import request from "@/service";

/* 查询草稿箱列表 */
export function draftsList(data) {
  return request({
    url: "/user/mq/drafts/page",
    method: "get",
    params: data
  });
}

/* 删除草稿 */
export function deleteDrafts(data) {
  return request({
    url: "/user/mq/drafts/delete",
    method: "delete",
    data
  });
}

/* 获取草稿详情 */
export function getDraftsInfo(data) {
  return request({
    url: `/user/mq/drafts/info/${data}`,
    method: "get"
  });
}
